import { render, staticRenderFns } from "./displayButtonWidge.vue?vue&type=template&id=a31b2c9c&scoped=true"
import script from "./displayButtonWidge.vue?vue&type=script&lang=js"
export * from "./displayButtonWidge.vue?vue&type=script&lang=js"
import style0 from "./displayButtonWidge.vue?vue&type=style&index=0&id=a31b2c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31b2c9c",
  null
  
)

export default component.exports